import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import { useModal, CopyLink } from '@mssgme/ui';
import { useExpired } from './hooks';
import InstaModalDialog from './InstaModalDialog';

import iconEmail from '../../../img/email.svg';
import iconEmbed from '../../../img/embed.svg';
import iconLink from '../../../img/link.svg';
import iconQr from '../../../img/qr.svg';

import styles from './MoreVisits.scss';

MoreVisits.propTypes = {
    url: PropTypes.string.isRequired,
};

export default function MoreVisits({ url }) {
    const { t } = useTranslation('cards');
    const [isExpired, renew] = useExpired('insta_share_expire', 14);
    const modal = useModal();

    const handleCopy = () => {
        if (isExpired) {
            modal.show();
            renew();
        }
    };

    return (
        <div>
            <InstaModalDialog {...modal.props} />
            <Section>
                <img src={iconLink} className={styles.mainIcon} alt="" />
                <p className={styles.headingTitle}>{t('pageShare.my_link')}</p>
                <CopyLink legacy share className={styles.userLink} href={url} onCopy={handleCopy} />
                <p className={styles.headingInstruction}>{t('pageShare.add_link')}</p>
            </Section>
            <SectionLink to="/p/share/qr">
                <img src={iconQr} className={styles.mainIcon} alt="" />
                <p className={styles.headingTitle}>{t('pageShare.my_qr')}</p>
                <p className={styles.headingInstruction}>{t('pageShare.copy_qr')}</p>
            </SectionLink>
            <SectionLink to="/p/share/sign">
                <img src={iconEmail} className={styles.mainIcon} alt="" />
                <p className={styles.headingTitle}>{t('pageShare.emailSign')}</p>
                <p className={styles.headingInstruction}>{t('pageShare.emailSign_descr')}</p>
            </SectionLink>
            <SectionLink to="/p/share/widget">
                <img src={iconEmbed} className={styles.mainIcon} alt="" />
                <p className={styles.headingTitle}>{t('pageShare.my_widget')}</p>
                <p className={styles.headingInstruction}>{t('pageShare.widget_settings')}</p>
            </SectionLink>
        </div>
    );
}

// eslint-disable-next-line react/prop-types
function Section({ as: Component = 'div', ...rest }) {
    return <Component className={styles.sectionBlock} {...rest} />;
}

// eslint-disable-next-line react/prop-types
function SectionLink({ to, children }) {
    return (
        <Section as={Link} to={to}>
            {children}
            <FaChevronRight size={16} className={styles.chevronRight} />
        </Section>
    );
}
